import styled from "styled-components/macro";
import { SecondaryButton, LabeledButtonMultiple } from "@loanbossinc/component-library";

export const StyledSecondaryButton = styled(SecondaryButton)`
  && {
    color: #005aa9;
    border: 1px solid #005aa9;

    &:hover {
      color: #005aa9;
      border: 1px solid #005aa9;
    }
  }
`;

export const PaddedWrapper = styled.div`
  && {
    padding: ${props => props.padding || "0 1em 0 1em"};
  }
`;

export const PaddedWrapperFullWidth = styled.div`
  padding: ${props => props.padding || "1.5em 1em 1.5em 1em"};
  width: 100%;
`;

export const ColumnWrapper = styled.div`
  && {
    display: flex;
    flex-direction: row;
    justify-content: "flex-start";
  }
`;

export const StyledInfo = styled.div`
  font-family: Work Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Title = styled.div`
  font-family: Work Sans;
  font-size: ${props => props.fontSize || "16px"};
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  padding-top: ${props => props.paddingTop || 0};
  text-align: left;
`;

export const Row = styled.div`
  && {
    align-items: center;
    border-bottom: ${props => props.borderBottom || "1px solid #dadce0"};
    box-sizing: border-box;
    display: flex;
    min-height: ${props => (props.minHeight ? props.minHeight : "88px")};
    justify-content: ${props => props.justifyContent || "space-between"};
    width: 100%;
  }
`;

export const Header = styled.div`
  && {
    align-items: center;
    background: #ffffff;
    border: 1px solid #dadce0;
    box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
    box-sizing: border-box;
    display: flex;
    height: 88px;
    justify-content: space-between;
    margin-bottom: 2em;
    width: 100%;
  }
`;

export const StyledButtonMultiple = styled(LabeledButtonMultiple)`
  filter: drop-shadow(0px 10px 20px rgba(173, 174, 174, 0.25));
  && div {
    height: 120px;
    width: 120px;

    button {
      padding: 1.4em;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
`;
